import { Button, Group, Iframe, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useTheme } from "@/comn/hooks";
import { APIS, SF_EWC_SRCH } from "@/tra/tancis/ptli/temp/dw/services/TdwiDwService";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/*
 * DW Iframe Page
 * !== DW Ifame Page ==!
 */
export const EWCI1001008Q = () => {
    const { menuId } = usePage();
    const modal = useModal();
    const { t } = useTranslation();
    const ewacsOptions: any = [
        {
            label: "Cargo",
            value: `${process.env.REACT_APP_KIBANA_EWCI1001008Q_CARGO_MONITORING}`,
        },
        {
            label: "Clearance",
            value: `${process.env.REACT_APP_KIBANA_EWCI1001008Q_TANSAD_MONITORING}`,
        },
        {
            label: "LPCO",
            value: `${process.env.REACT_APP_KIBANA_EWCI1001008Q_LPCO_MONITORING}`,
        },
    ];

    const [iframeSrc, setIframeSrc] = useState("");

    const form = {
        ewcSrch: useForm({ defaultSchema: SF_EWC_SRCH }),
    };

    const handler = {
        handleChange: (v: any) => {
            setIframeSrc(v);
        },
    };

    useEffect(() => {
        setIframeSrc(ewacsOptions[0].value);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.ewcSrch.schema.ewacType}
                                options={ewacsOptions}
                                onChange={handler.handleChange}
                            />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {iframeSrc && (
                <Group>
                    <Group.Body>
                        <Iframe src={iframeSrc} height={800} />
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
